import { ControllerFlowAPI } from 'yoshi-flow-editor-runtime/build/cjs/flow-api/ViewerScript';
import { userProviderPropsMap } from '../../User/userProviderPropsMap';
import { paidPlansBenefitsApi } from '@wix/challenges-web-api/dist/src/API';
import { APPS } from '../../../config/constants';
import {
  GetEligibleOrdersRequest,
  GetEligibleOrdersResponse,
  MemberOrdersByPlan,
} from '@wix/ambassador-pricing-plan-benefits-server/types';
import { UserState } from '../../User/UserContext';
import { handleError } from '../../ErrorHandler/errorHandlerPropsMap';
import { getChallengeId } from '../../ChallengeDataProvider/challengeDataProviderPropsMap';
import { isMockedChallenge } from '../../main/getMockedChallenges';

export async function getUserEligiblePlans(
  flowAPI: ControllerFlowAPI,
  challengeId?: string,
): Promise<MemberOrdersByPlan[]> {
  const user = await userProviderPropsMap(flowAPI);
  challengeId = challengeId ? challengeId : await getChallengeId(flowAPI);

  if (
    !challengeId ||
    user.userType === UserState.VISITOR ||
    isMockedChallenge(challengeId, flowAPI)
  ) {
    return [];
  }
  try {
    const response: GetEligibleOrdersResponse = await paidPlansBenefitsApi.membersService.getEligibleOrders(
      {
        appDefId: APPS.Prod,
        resourceId: challengeId,
        contactId: user.user.id,
        targetDate: new Date().toISOString(),
      } as GetEligibleOrdersRequest,
    );

    return response.memberOrdersByPlan;
  } catch (error) {
    handleError({
      context: 'getEligibleOrders',
      error,
    });
    return [];
  }
}
